import { Able, MoveableManagerInterface } from "moveable";
import { html } from "tagged-jsx";
import Interactable from "../interactable";
import store from "../../store";
import * as actions from "../../actions";
import { JSXInternal } from "preact/src/jsx";
import CSSProperties = JSXInternal.CSSProperties;
import util from "../../util";
import OwnRenderer from "../renderer";
import { markAsModified } from "../mark-as-modified";
import MenuObject from "../menu-object";
import { ABLE_OFFSET } from "../interactable-constants";

interface MOOptionsProps {
  mooptions: boolean;
  interactable: Interactable;
}

const MOOptions = {
  name: "mooptions",
  props: {
    interactable: Interactable
  },
  render(moveable: MoveableManagerInterface<MOOptionsProps>, Renderer) {
    const isMobile = store.getState().isMobileVersion;
    const rect = moveable.getRect();
    const $contextBar = isMobile ? $('#app-header') : $('.context-bar');

    ABLE_OFFSET.reset();
    let top = ABLE_OFFSET.MOOPTIONS;
    if ($contextBar.length) {
      const contextBarRect = $contextBar[0].getBoundingClientRect();
      const elementRect = moveable.props.interactable.getElement()[0].getBoundingClientRect();
      const isBelowBar = elementRect.top + top - contextBarRect.bottom < 0;

      if (isBelowBar) {
        const newOffset = 20;
        ABLE_OFFSET.ANGLE += newOffset;
        ABLE_OFFSET.DIM += newOffset;
        top = rect.height + newOffset;
      }
    }

    const style = {
      position: "absolute",
      left: `${rect.width / 2}px`,
      top: `${top}px`,
      bottom: `20px`,
      color: "black",
      fontSize: "13px",
      whiteSpace: "nowrap",
      fontWeight: "bold",
      willChange: "transform",
      transform: "translate(-50%, 0px)",
    } as CSSProperties;

    util.nextTick(() => {
      const $delBtn = $('.mo-option.delete');
      const $addBtn = $('.mo-option.add');
      const $importBtn = $('.mo-option.import');
      const $moreBtn = $('.mo-option.more');
      $delBtn.off('click');
      $addBtn.off('click');
      $importBtn.off('click');
      $moreBtn.off('click');
      $delBtn.on('click', function () {
        // @ts-ignore
        window.ConfirmationModal.show({
          title: 'Are you sure?',
          body: 'This group will be removed and all its data will be lost.',
          acceptLabel: 'Delete',
          declineLabel: 'Cancel',
          onAccept: () => {
            store.dispatch(actions.setSelectionType('text'));
            store.dispatch(actions.showLayoutGuideBar(false));
            //@ts-ignore
            OwnRenderer.remove(moveable.props.interactable.$el, false);
            store.dispatch(actions.deselect());
          },
          onDecline: () => {
            // @ts-ignore
            window.ConfirmationModal.hide()
          }
        });
      });
      $importBtn.on('click', function () {
        store.dispatch(actions.setIsDataLibraryModal(true));
      });
      $addBtn.on('click', function (e) {
        MenuObject.moAddItem(moveable.props.interactable.getElement());
        e.stopPropagation();
      });
      $moreBtn.on('click', function(e) {
        store.dispatch(actions.setIsMobileAside(true));
        store.dispatch(actions.goToView('text-mo'));
        store.dispatch(actions.goToSubview('add-new'));
      });
    });

    return html`<div class="mo-options" style=${style}>
      <div class="mo-option hint--bottom add" data-hint="Add new item">
          <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" viewBox="0 0 28 28">
              <path fill="#333" d="M14.784 5h-1.57c-.139 0-.209.07-.209.21v8.214H5.21c-.14 0-.209.07-.209.21v1.57c0 .139.07.209.21.209h7.795v8.215c0 .14.07.21.21.21h1.57c.139 0 .209-.07.209-.21v-8.215h7.797c.14 0 .209-.07.209-.21v-1.57c0-.139-.07-.209-.21-.209h-7.796V5.21c0-.14-.07-.209-.21-.209z"></path>
          </svg>
      </div>
      <div class="mo-option hint--bottom import" data-hint="Import item">
          <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" viewBox="0 0 28 28">
              <path fill="#333" d="M23.473 19.571h-1.307a.19.19 0 00-.188.19v1.53h-15.3V5.71h15.303v1.528c0 .104.085.19.187.19h1.307a.189.189 0 00.187-.19V4.76a.752.752 0 00-.746-.76H5.746A.751.751 0 005 4.76v17.48c0 .421.333.76.746.76h17.168a.751.751 0 00.746-.76v-2.478a.189.189 0 00-.187-.19zm.333-6.962h-7.63v-1.88c0-.166-.189-.26-.315-.156l-3.448 2.771a.198.198 0 00-.075.156.201.201 0 00.075.156l3.448 2.77c.128.105.316.01.316-.155v-1.88h7.629a.197.197 0 00.194-.198v-1.386a.197.197 0 00-.194-.198z"></path>
          </svg>
      </div>
      <div class="mo-option hint--bottom delete" data-hint="Delete">
          <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" viewBox="0 0 28 28">
              <path fill="#333" d="M10.438 6.688h-.188a.188.188 0 00.188-.188v.188h7.124V6.5a.19.19 0 00.188.188h-.188v1.687h1.688V6.5c0-.827-.673-1.5-1.5-1.5h-7.5c-.827 0-1.5.673-1.5 1.5v1.875h1.688V6.687zM22.25 8.374H5.75a.75.75 0 00-.75.75v.75c0 .103.084.188.188.188h1.415l.579 12.257c.038.8.698 1.43 1.498 1.43h10.64c.802 0 1.46-.628 1.498-1.43l.579-12.258h1.416A.188.188 0 0023 9.876v-.75a.75.75 0 00-.75-.75zm-3.11 13.688H8.86l-.567-12h11.414l-.567 12z"></path>
          </svg>
      </div>
      <div class="mo-option more">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="5 12 18 3">
            <g id="More">
              <path id="Vector" d="M5 13.5C5 13.697 5.0388 13.892 5.11418 14.074C5.18956 14.256 5.30005 14.4214 5.43934 14.5607C5.57863 14.6999 5.74399 14.8104 5.92597 14.8858C6.10796 14.9612 6.30302 15 6.5 15C6.69698 15 6.89204 14.9612 7.07403 14.8858C7.25601 14.8104 7.42137 14.6999 7.56066 14.5607C7.69995 14.4214 7.81044 14.256 7.88582 14.074C7.9612 13.892 8 13.697 8 13.5C8 13.303 7.9612 13.108 7.88582 12.926C7.81044 12.744 7.69995 12.5786 7.56066 12.4393C7.42137 12.3001 7.25601 12.1896 7.07403 12.1142C6.89204 12.0388 6.69698 12 6.5 12C6.30302 12 6.10796 12.0388 5.92597 12.1142C5.74399 12.1896 5.57863 12.3001 5.43934 12.4393C5.30005 12.5786 5.18956 12.744 5.11418 12.926C5.0388 13.108 5 13.303 5 13.5ZM12.5 13.5C12.5 13.8978 12.658 14.2794 12.9393 14.5607C13.2206 14.842 13.6022 15 14 15C14.3978 15 14.7794 14.842 15.0607 14.5607C15.342 14.2794 15.5 13.8978 15.5 13.5C15.5 13.1022 15.342 12.7206 15.0607 12.4393C14.7794 12.158 14.3978 12 14 12C13.6022 12 13.2206 12.158 12.9393 12.4393C12.658 12.7206 12.5 13.1022 12.5 13.5ZM20 13.5C20 13.8978 20.158 14.2794 20.4393 14.5607C20.7206 14.842 21.1022 15 21.5 15C21.8978 15 22.2794 14.842 22.5607 14.5607C22.842 14.2794 23 13.8978 23 13.5C23 13.1022 22.842 12.7206 22.5607 12.4393C22.2794 12.158 21.8978 12 21.5 12C21.1022 12 20.7206 12.158 20.4393 12.4393C20.158 12.7206 20 13.1022 20 13.5Z" fill="#333333"/>
            </g>
          </svg>
      </div>
    </div>`(Renderer.createElement);
  },
} as Able;

export default MOOptions;
